import { render, staticRenderFns } from "./ClientOrders.vue?vue&type=template&id=83d6a51e&"
import script from "./ClientOrders.vue?vue&type=script&lang=js&"
export * from "./ClientOrders.vue?vue&type=script&lang=js&"
import style0 from "./ClientOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports